import { useState } from 'react'

export const typeFilePreviewPdf = [
	'application/pdf',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/msword',
	'application/doc',
	'application/docx',
	'application/x-ole-storage',
]

export const useUploadField = (files) => {
	const [activeImage, setActiveImage] = useState({})
	const [showPreview, setShowPreview] = useState()
	const handlePreviewPdf = (item) => {
		window.open(item?.fileUrl || item?.src, '_blank')
	}

	const handlePreviewImage = (item) => {
		setActiveImage({
			url: item?.imageUrls?.s_500x500 || item?.src || item?.fileUrl,
			title: item.filename,
		})
		setShowPreview(true)
	}

	const handleSelectImgList = (item) => {
		setActiveImage({
			url: item?.src || item?.fileUrl,
			title: item?.alt,
		})
	}

	const listImageSlider = files
		?.filter((item) => !item.hasOwnProperty('_destroy'))
		.map((item) => {
			return {
				alt: item?.filename,
				src: item?.imageUrls?.s_500x500 || item?.src || item?.fileUrl,
				id: item?.id,
				contentType: item?.contentType,
			}
		})

	return {
		listImageSlider,
		handleSelectImgList,
		handlePreviewImage,
		handlePreviewPdf,
		activeImage,
		setActiveImage,
		showPreview,
		setShowPreview,
	}
}
